/**
 * @desc 导出SKU库存列表
 */
const URL = "/rantion-stock";
import http, { updateResponse } from "@/http";
export function request(params: API.stock.stockSku.exportListStockSku.Params, options?: any) {
  return updateResponse(
    http(URL + `/stock/sku/export/list`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
